import { useSeoMeta } from "@unhead/react";
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useSeoMeta({
    title: "404 - Page Not Found",
    description: "The page you are looking for could not be found. Return to the home page to continue browsing.",
  });

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Trippy animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-fuchsia-500 via-violet-600 via-cyan-400 to-emerald-400 dark:from-fuchsia-900 dark:via-violet-950 dark:via-cyan-900 dark:to-emerald-900 animate-gradient-shift" />
      
      {/* Floating gradient orbs */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-gradient-to-r from-rose-400 to-amber-300 opacity-40 blur-3xl animate-pulse" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full bg-gradient-to-r from-sky-400 to-violet-500 opacity-40 blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-gradient-to-r from-emerald-300 to-cyan-400 opacity-30 blur-3xl animate-pulse" style={{ animationDelay: '0.5s' }} />

      {/* Content */}
      <div className="relative z-10 text-center space-y-8 px-6">
        {/* Big eye */}
        <div className="relative w-40 h-40 mx-auto">
          <div className="absolute inset-0 rounded-full bg-white/20 backdrop-blur-sm animate-pulse" />
          <div className="absolute inset-4 rounded-full bg-gradient-to-br from-amber-200 via-rose-200 to-violet-300" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-8xl drop-shadow-2xl animate-bounce" style={{ animationDuration: '2s' }}>
              👁️
            </span>
          </div>
        </div>

        {/* Message */}
        <div className="space-y-2">
          <p className="text-2xl md:text-3xl font-medium text-white drop-shadow-lg">
            Return home, traveler
          </p>
        </div>

        {/* Button */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white/20 backdrop-blur-md text-white font-medium text-lg border border-white/30 hover:bg-white/30 hover:scale-105 active:scale-95 transition-all shadow-xl"
        >
          <span>Take me home</span>
        </Link>
      </div>

      {/* CSS for gradient animation */}
      <style>{`
        @keyframes gradient-shift {
          0%, 100% { filter: hue-rotate(0deg); }
          50% { filter: hue-rotate(30deg); }
        }
        .animate-gradient-shift {
          animation: gradient-shift 8s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default NotFound;
